import React, { useState, useEffect, useRef } from "react";

import "./login.css";
import LoginForm from "../components/forms/LoginForm";
import { Link } from 'react-router-dom';

const LoginPage = () => {
  return (
    <div className="login-page">
      <header className="login-title">Login</header>
      <div className="button-div">
        <LoginForm />
        <Link to="/signup">
          <button className="signup-button custom-button">
            SIGN UP
          </button>
        </Link>
      </div>
    </div>
  );
}

export default LoginPage;